const NAMESPACE = 'DUCKS/HOMEPAGE';

export default NAMESPACE;
